import { atom } from 'jotai';
export const $InstalledRelatedApp = atom('pending');
$InstalledRelatedApp.debugLabel = '$InstalledRelatedApp';
export const $IsAppInstalled = atom((get) => {
    const installedRelatedApp = get($InstalledRelatedApp);
    return !['pending', null].includes(installedRelatedApp);
});
$IsAppInstalled.debugLabel = '$IsAppInstalled';
